import { useEffect } from 'react';
import { useLocation, BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import ComingSoon from "./pages/ComingSoon";
import Bio from "./pages/Bio";
import Donate from "./pages/Donate";
import Admin from "./pages/Admin";
import Article from "./pages/Article";
import Articles from "./pages/Articles";
import About from "./pages/About";
import PromptManager from "./pages/PromptManager";
import VasilenkoAI from "./pages/VasilenkoAI";
import AmazonFBA from "./pages/AmazonFBA";
import UpworkJourney from "./pages/UpworkJourney";
import AIAutomation from "./pages/AIAutomation";
import Biography from "./pages/Biography";
import Haieren from "./pages/Haieren";
import Links from "./pages/Links";
import Vibe from "./pages/Vibe";
import VibeCourse from "./pages/VibeCourse";
import VibeSignup from "./pages/VibeSignup";
import ThankYou from "./pages/ThankYou";

// gtag TypeScript declaration
declare global {
  interface Window {
    gtag?: (key: string, trackingId: string, config: { page_path: string }) => void;
  }
}

// Analytics tracking component - THIS IS THE NEW PART
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-162Z1HENHZ', {
        'page_path': location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component does not render anything
};

// Initialize QueryClient and Stripe
const queryClient = new QueryClient();
const stripePromise = loadStripe("pk_live_51PdYJCApd1gKzZQ5r89qjQ41wlPqjfw9NA0kCDkJaaS9McsfNaGPNehoZZrCrQlk49CO6t8QHxaZaNYf20X986LI00ha9RdYQ9");


const App = () => {
  // The tracking logic has been moved out of here.
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <PageTracker /> {/* The tracking component is now correctly placed INSIDE the router */}
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/bio" element={<Bio />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/about" element={<About />} />
            <Route path="/prompt-manager" element={<PromptManager />} />
            <Route path="/haieren" element={<Haieren />} />
            <Route path="/links" element={<Links />} />
            <Route path="/vibe" element={<Vibe />} />
            <Route path="/vibe-signup" element={<VibeSignup />} />
            {/* <Route path="/vibe-course" element={<VibeCourse />} /> */}
            <Route path="/thank-you" element={<ThankYou />} />
            {/* <Route path="/donate" element={
              <Elements stripe={stripePromise}>
                <Donate />
              </Elements>
            } /> */}
            <Route path="/article/:slug" element={<Article />} />
            <Route path="/biography" element={<Biography />} />
            <Route path="/products/ai-automation" element={<AIAutomation />} />
            <Route path="/products/vasilenko-ai" element={<VasilenkoAI />} />
            <Route path="/projects/amazon" element={<AmazonFBA />} />
            <Route path="/projects/upwork" element={<UpworkJourney />} />
            <Route path="/products/prompt-manager" element={<PromptManager />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;